var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background":"#F8F8F8"},attrs:{"id":"app"}},[( !_vm.getbIncrustado && _vm.bLogin )?_c('Modulos'):_vm._e(),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('Notificacion')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }